'use client';
import React from 'react';

export default function ManifestoPage() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 56px)',
        padding: '24px',
      }}
    >
      <p
        style={{
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontSize: '20px',
          fontWeight: '700',
          color: 'var(--color-text-primary)',
          margin: 0,
          textAlign: 'center',
        }}
      >
        Bold, daring, and accessible
      </p>
    </div>
  );
}
